import { z } from 'zod'
import { uuidSchema } from '../validators/uuid.validator.js'

/** The authenticated user shape the API returns and the web app stores. */
export const authUserDtoSchema = z.object({
  id: uuidSchema,
  email: z.string().email(),
  name: z.string(),
})

export type AuthUserDto = z.infer<typeof authUserDtoSchema>

/** Response from `POST /auth/login`. */
export const loginResponseDtoSchema = z.object({
  accessToken: z.string(),
  user: authUserDtoSchema,
})

export type LoginResponseDto = z.infer<typeof loginResponseDtoSchema>
